module.exports = __webpack_public_path__ + "img/work2.c9dc532b.gif";